module.exports = __webpack_public_path__ + "linkedin-rounded-de56017ad4a874bcebb2.svg";